import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly messages = inject(MessageService);

  success(detail: string, summary = 'Done'): void {
    this.messages.add({ severity: 'success', summary, detail, life: 3500 });
  }

  error(detail: string, summary = 'Couldn’t complete'): void {
    if (!detail?.trim()) {
      return;
    }
    this.messages.add({ severity: 'error', summary, detail, life: 6500 });
  }

  warn(detail: string, summary = 'Please check'): void {
    this.messages.add({ severity: 'warn', summary, detail, life: 5000 });
  }

  info(detail: string, summary = 'Note'): void {
    this.messages.add({ severity: 'info', summary, detail, life: 4500 });
  }
}
